"use client";

import clsx from "clsx";
import type { ComponentProps } from "react";

import { Body } from "@shared/ui/typography";

import type { TrailPageType } from "@/_pages/single-trail/model/types";

import { TrailListItem } from "../trail-list-item";

import s from "./trails-table.module.scss";

export type TrailsTableProps = ComponentProps<"div"> & {
  className?: string;
  trails: TrailPageType[];
};

export const TrailsTable = (props: TrailsTableProps) => {
  const { className, trails } = props;

  if (trails.length === 0) {
    return null;
  }

  return (
    <div className={clsx(s.root, className)}>
      <Body tag="div" size="primary" weight="semiBold" className={s.header}>
        <div className={s.cell}>Номер и название</div>
        <div className={s.cell}>Статус</div>
        <div className={s.cell}>Протяженность</div>
        <div className={s.cell}>Начальная высота</div>
        <div className={s.cell}>Конечная высота</div>
        <div className={s.cellMobile}>Трасса</div>
      </Body>
      {trails.map((trail) => (
        <TrailListItem
          key={trail.id}
          trail={trail}
          className={s.row}
          cellClassName={s.cell}
        />
      ))}
    </div>
  );
};

TrailsTable.displayName = "TrailsTable";
